import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '@shared/ui';

interface OAuthLayoutProps {
  children: ReactNode;
}

export function OAuthLayout({ children }: OAuthLayoutProps) {
  const { t } = useTranslation();
  return (
    <div className="flex h-dvh w-full flex-col overflow-y-auto bg-base px-5 py-8 sm:px-8 md:px-12 md:py-10">
      <div className="mb-8 flex items-center justify-between gap-4">
        <Logo />
        <div className="text-[12px] font-medium uppercase tracking-[0.16em] text-muted">
          {t('auth.oauth.kicker')}
        </div>
      </div>
      <div className="flex flex-1 items-center justify-center">{children}</div>
      <div className="text-[12px] font-medium uppercase tracking-[0.14em] text-muted-2">
        {t('auth.versionSecure')}
      </div>
    </div>
  );
}
